import { render, staticRenderFns } from "./PricingPageLoading.vue?vue&type=template&id=90a4df42&scoped=true&"
import script from "./PricingPageLoading.vue?vue&type=script&lang=js&"
export * from "./PricingPageLoading.vue?vue&type=script&lang=js&"
import style0 from "./PricingPageLoading.vue?vue&type=style&index=0&id=90a4df42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a4df42",
  null
  
)

export default component.exports